import React, { useState, useEffect } from "react";
import TitledSection from "../../../components/generic/titledSection.js";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import theme from "../../../helpers/theme.js";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import StyledTextUpdate from "../../../components/generic/StyledTextUpdate.jsx";
import CompanySelectV2 from "../../../components/generic/CompanySelectV2.jsx";
import {
  backendGetRequest,
  backendPatchWithoutRefresh,
} from "../../../helpers/callBackend.js";
import OuterBox from "../../../components/generic/arpariBoxes/OuterBox.js";
import PhoneNumberInput from "../../../components/generic/PhoneNumberInput.jsx";

const PersonalInformation = () => {
  const [currentUcs, setCurrentUcs] = useState({});
  const [profile, setProfile] = useState({
    firstName: "",
    lastName: "",
    email: "",
    permission: "",
    phoneNumber: "",
  });

  const [tableData, setTableData] = useState([]);

  const createRow = (name, content) => {
    return { name, content };
  };

  const updateUserInfo = (ucsObject) => {
    setCurrentUcs(ucsObject);
    setProfile({
      firstName: ucsObject.first_name ? ucsObject.first_name : "Unknown",
      lastName: ucsObject.last_name ? ucsObject.last_name : "Unknown",
      email: ucsObject.email,
      permission: ucsObject.is_admin ? "Admin" : "Member",
      phoneNumber: ucsObject.phone_number ? ucsObject.phone_number : "1234567890",
    });
  };

  const getUcsObjects = async () => {
    const ucsResp = await backendGetRequest("/api/user/user-company-settings");
    if (ucsResp.status != 200) {
      return;
    }
    updateUserInfo(ucsResp.data.data.active_ucs);
  };

  const updateUcs = async (settingsObject) => {
    const data = {
      company_id: currentUcs.company,
      email: currentUcs.email,
      settings: { ...settingsObject },
    };
    const ucsResp = await backendPatchWithoutRefresh(
      "/api/user/user-company-settings",
      data
    );
    if (ucsResp.status != 200) {
      return;
    }
    updateUserInfo(ucsResp.data.data);
  };

  useEffect(() => {
    getUcsObjects();
  }, []);

  useEffect(() => {
    const firstNameContent = (
      <StyledTextUpdate
        defaultValue={profile.firstName}
        onSave={(value) => {
          updateUcs({ first_name: value });
        }}
      />
    );
    const lastNameContent = (
      <StyledTextUpdate
        defaultValue={profile.lastName}
        onSave={(value) => {
          updateUcs({ last_name: value });
        }}
      />
    );
    const phoneNumberContent = (
      <PhoneNumberInput
        defaultValue={profile.phoneNumber}
        onSave={(value) => {
          updateUcs({ phone_number: value });
        }}
      />
    );
    const emailContent = <Typography>{profile.email}</Typography>;
    const permissionContent = <Typography>{profile.permission}</Typography>;
    const companyContent = <CompanySelectV2 width="50%" />;

    const rows = [
      createRow("First Name", firstNameContent),
      createRow("Last Name", lastNameContent),
      createRow("Phone Number", phoneNumberContent),
      createRow("Email", emailContent),
      createRow("Permission", permissionContent),
      createRow("Current Company", companyContent),
    ];
    setTableData(rows);
  }, [profile]);

  return (
    <OuterBox>
      <Box sx={{ margin: theme.dashboard.margins }}>
        <TitledSection
          title="Personal Information"
          body={
            <TableContainer
              sx={{
                width: "100%",
                borderTop: 1,
                borderRight: 1,
                borderLeft: 1,
                borderColor: theme.palette.secondary.light,
              }}
            >
              <Table>
                {tableData.map((row) => (
                  <TableRow>
                    <TableCell
                      align="right"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: "10%",
                        borderRight: 1,
                        borderColor: theme.palette.secondary.light,
                      }}
                    >
                      <Typography>{row.name}</Typography>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: "30%",
                      }}
                    >
                      {row.content}
                    </TableCell>
                  </TableRow>
                ))}
              </Table>
            </TableContainer>
          }
        />
      </Box>
    </OuterBox>
  );
};

export default PersonalInformation;
